// Simple cookie helpers with sane defaults
export type SameSite = 'Lax' | 'Strict' | 'None';

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${encodeURIComponent(name)}=`);
  if (parts.length === 2) {
    const part = parts.pop()!;
    return decodeURIComponent(part.split(';').shift() || '');
  }
  return null;
}

export function setCookie(
  name: string,
  value: string,
  options: {
    days?: number;
    path?: string;
    sameSite?: SameSite;
    secure?: boolean;
    domain?: string;
  } = {}
): void {
  if (typeof document === 'undefined') return;
  const {
    days = 365,
    path = '/',
    sameSite = 'Lax',
    secure = (typeof window !== 'undefined' && window.location?.protocol === 'https:'),
    domain,
  } = options;

  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; ${expires}; path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += '; Secure';
  if (domain) cookie += `; Domain=${domain}`;

  document.cookie = cookie;
}

export function deleteCookie(name: string, path: string = '/'): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}`;
}
